/*****************************************
ミツカン試食室 - 共通 JavaScript
*****************************************/

/**
 * 星レーティングの初期化
 */
window.initStarRatings = () => {
  document.querySelectorAll('.tasting-room-star-rating__group').forEach(updateStarRating);
}

/**
 * 星レーティングの更新
 */
window.updateStarRating = (groupEl) => {
  const rating = parseFloat(groupEl.dataset.rating);
  const filledStarElems = groupEl.querySelectorAll('.tasting-room-star-rating__filled');
  const emptyStarElems = groupEl.querySelectorAll('.tasting-room-star-rating__empty');

  filledStarElems.forEach(star => star.style.width = '0px');

  const integerStar = Math.floor(rating);
  const fractionStar = rating - integerStar;
  
  // 要素が表示されていないと幅が取れないため、非表示の場合はスキップ
  const emptyStartWidthStyle = getComputedStyle(emptyStarElems[0]).width;
  const emptyStartWidth = emptyStartWidthStyle.replace('px', '');
  
  if (emptyStartWidth && parseFloat(emptyStartWidth) > 0) {
    filledStarElems.forEach((filledStarElem, index) => {
      if (index < integerStar) {
        filledStarElem.style.width = `${emptyStartWidth}px`;
      } else if (index === integerStar) {
        filledStarElem.style.width = `${emptyStartWidth * fractionStar}px`;
      }
    });
  }
}
